import { Card, Skeleton } from "@nextui-org/react";
import React from "react";

const SkeletonUI = ({
  cardId,
  noOfLines = 1,
  widthClass = "w-full",
  className,
  noOfButtons = 1,
}) => {
  return (
    <>
      {cardId === "mystore_card_skeleton" && (
        <Card
          className="mb-2 w-full h-[260px] space-y-5 px-1 py-0.5"
          radius="md"
        >
          <Skeleton className="rounded-lg">
            <div className="w-[120px] h-[150px] rounded-t-md bg-default-300"></div>
          </Skeleton>
          <div className="space-y-3 px-2">
            <Skeleton className="w-3/5 rounded-lg">
              <div className="h-3 w-3/5 rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton className="w-4/5 rounded-lg">
              <div className="h-3 w-4/5 rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton className="w-2/5 rounded-lg">
              <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
            </Skeleton>
          </div>
        </Card>
      )}
      {cardId === "horizontal-card-skeleton" && (
        <Card className="mb-2 w-full h-[120px] space-x-5" radius="md">
          <div className="flex space-x-2 w-full">
            <div className="p-2">
              <Skeleton className="rounded-lg">
                <div className="w-[120px] h-[100px] rounded-t-md bg-default-300 p-2"></div>
              </Skeleton>
            </div>
            <div className="space-y-3 py-2 w-full p-2">
              <Skeleton className="rounded-lg">
                <div className="h-3  rounded-lg bg-default-200"></div>
              </Skeleton>
              <Skeleton className=" rounded-lg">
                <div className="h-3 rounded-lg bg-default-200"></div>
              </Skeleton>
              <Skeleton className=" rounded-lg">
                <div className="h-3 rounded-lg bg-default-200"></div>
              </Skeleton>
              <Skeleton className="w-3/5 rounded-lg">
                <div className="h-3 w-3/5 rounded-lg bg-default-300"></div>
              </Skeleton>
              <Skeleton className="w-2/5 rounded-lg">
                <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
              </Skeleton>
            </div>
          </div>
        </Card>
      )}

      {cardId === "heading" &&
        Array.from({ length: noOfLines }).map((_, index) => (
          <Skeleton
            className={`w-full rounded-sm my-1 ${widthClass} ${className} `}
          >
            <div
              className={`h-3 w-full rounded-lg bg-default-300 ${widthClass} `}
            ></div>
          </Skeleton>
        ))}
      {cardId === "button" && (
        <>
          {Array.from({ length: noOfButtons }).map((item) => (
            <Skeleton className={`rounded-sm my-1 ${className}`} key={item}>
              <div className={`${className} rounded-lg bg-default-300`}></div>
            </Skeleton>
          ))}
        </>
      )}
      {cardId === "icon" && (
        <Skeleton className="w-10 h-10 rounded-lg my-1">
          <div className="h-10 w-10 rounded-lg bg-default-300"></div>
        </Skeleton>
      )}
      {cardId === "financial_card_skeleton" && (
        <div className="flex flex-col pb-4">
          <div className="flex justify-between py-2">
            <Skeleton className="rounded-lg w-[20%]">
              <div className="h-3 w-[20%] rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton className="rounded-lg w-[60%]">
              <div className="h-3 w-[60%] rounded-lg bg-default-200"></div>
            </Skeleton>
          </div>
          <div className="flex justify-between py-2">
            <Skeleton className="rounded-lg w-[60%]">
              <div className="h-3 w-[60%] rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton className="rounded-lg w-[20%]">
              <div className="h-3 w-[20%] rounded-lg bg-default-200"></div>
            </Skeleton>
          </div>
          <div className="flex justify-between py-2">
            <Skeleton className="rounded-lg w-[20%]">
              <div className="h-3 w-[20%] rounded-lg bg-default-200"></div>
            </Skeleton>
            <Skeleton className="rounded-lg w-[60%]">
              <div className="h-3 w-[60%] rounded-lg bg-default-200"></div>
            </Skeleton>
          </div>
        </div>
      )}
    </>
  );
};

export default SkeletonUI;
